import { gql } from '@apollo/client'

export const POLICY_NUMBER_QUERY = gql`
  query policyNumber($policyNumber: String!, $insuranceId: ID!) {
    policyNumber(policyNumber: $policyNumber, insuranceId: $insuranceId) {
      id
      policyNumber
    }
  }
`
